<template>
  <div>
    <main class="l-content">
      <GridSection/>
    </main>
  </div>

</template>

<script>
  import GridSection from '../components/GridSection'
  export default {
    name: 'RestaurantsList',
    components: {GridSection}
  }
</script>

<style>

</style>
